import React, { useState } from "react";
import "../../DealApproval.scss";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import { isValidMeaningfulData } from "../helpers";

const StatusForm = ({ itemIndex, blockItem, statusOptions = [], onUpdateBlockItem, onDeleteBlockItem }) => {
    const [statusTitleError, setStatusTitleError] = useState("");
    const [descriptionError, setDescriptionError] = useState("");
    const defaultStatus = statusOptions[0]?.optionValue || "";

    const handleStatusTitleChange = (e) => {
        const value = e.target.value;
        onUpdateBlockItem(itemIndex, "statusTitle", value);

        const trimmedValue = value.trim();
        let error = "";

        if (!trimmedValue) {
            error = "Status title is required.";
        } else if (trimmedValue.length < 3) {
            error = "Status title must be at least 3 characters.";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
            error = "Status title must contain at least one alphabet.";
        } else if (!isValidMeaningfulData(trimmedValue)) {
            error = "Please enter a valid and meaningful data.";
        }

        setStatusTitleError(error);
    };

    const handleDescriptionChange = (e) => {
        const value = e.target.value;
        onUpdateBlockItem(itemIndex, "description", value);

        const rawValue = String(value || "");
        const trimmedValue = rawValue.trim();
        let error = "";

        if (!trimmedValue) {
            error = "Description is required.";
        } else if (trimmedValue.length < 4) {
            error = "Description must be at least 4 characters.";
        } else if (rawValue.length > 500) {
            error = "Description cannot exceed 500 characters.";
        } else if (/<[^>]*>/.test(trimmedValue)) {
            error = "Description cannot contain HTML or script tags.";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
            error = "Description must contain at least one alphabet.";
        } else if (/^[^A-Za-z0-9\s]+$/.test(trimmedValue) || /^\d+$/.test(trimmedValue) || !isValidMeaningfulData(trimmedValue)) {
            error = "Please enter a valid and meaningful data.";
        }

        setDescriptionError(error);
    };

    return (
        <>
            <div className="metric-header-row">
                <label>Status Title <span className="required-mark">*</span></label>
                <button
                    type="button"
                    className="card-delete-text-btn"
                    onClick={() => onDeleteBlockItem(itemIndex)}
                >
                    Delete
                </button>
            </div>
            <input
                type="text"
                placeholder="Enter Title for this status block..."
                value={blockItem.statusTitle || ""}
                maxLength={300}
                onChange={handleStatusTitleChange}
                className={statusTitleError ? "input-error" : ""}
            />
            <div className="error-counter-row">
                {statusTitleError ? <p className="form-error-text">{statusTitleError}</p> : <span className="error-placeholder" />}
                <span className="char-counter-text">{(blockItem.statusTitle || "").length}/300</span>
            </div>
            {(blockItem.statusTitle || "").length >= 300 && <p className="char-limit-note">Max 300 characters reached</p>}

            <div className="status-description-row">
                <div className="status-description-field">
                    <label>Description <span className="required-mark">*</span></label>
                    <input
                        type="text"
                        placeholder="Enter the description..."
                        value={blockItem.description || ""}
                        maxLength={500}
                        onChange={handleDescriptionChange}
                        className={descriptionError ? "input-error" : ""}
                    />
                    <div className="error-counter-row">
                        {descriptionError ? <p className="form-error-text">{descriptionError}</p> : <span className="error-placeholder" />}
                        <span className="char-counter-text">{(blockItem.description || "").length}/500</span>
                    </div>
                    {(blockItem.description || "").length >= 500 && <p className="char-limit-note">Max 500 characters reached</p>}
                </div>
                <div className="status-select-field">
                    <label>Status</label>
                    <CustomSelect
                        options={statusOptions.map((opt) => ({ value: opt.optionValue, label: opt.optionLabel }))}
                        value={blockItem.status || defaultStatus}
                        onChange={(value) => onUpdateBlockItem(itemIndex, "status", value)}
                    />
                </div>
            </div>
        </>
    );
};

export default StatusForm;
